import Immutable from "immutable";

export default {
    REMOVE_NOTIFICATION: (state, action) => {
        let content = state.get("content") || [];
        return state.set(
            "content",
            Immutable.fromJS(
                content.filter((entity, v) => {
                    return entity.get("id") !== action.payload.id;
                })
            )
        );
    },
    ADD_NOTIFICATIONS: (state, action) => {
        let content = state.get("content") || [];
        let counter = state.get("counter") || 0;
        if (content.toJS) {
            content = content.toJS();
        }

        if (action.payload.content.length) {
            action.payload.content.forEach(item => {
                item.id = counter;
                content.push(item);
                counter++;
            });
        }
        return state.set("content", Immutable.fromJS(content)).set("counter", counter);
    }
};
